import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ChevronRight } from '@bibliocommons/base-icons';
import Heading from '@bibliocommons/heading';

import { displayBibShape } from 'app/shapes';
import DisplayBibSlide from './DisplayBibSlide';

import './BibsRowBibs.scss';

const BibsRowBibs = ({ displayBibs, hasHistoryRoutingForTitles, title, titleUrl, trackBibClick, trackTitleClick }) => {
  const onTitleClick = () => {
    trackTitleClick({ titleText: title, titleUrl });
  };

  return (
    <div className="cp-bibs-row-bibs row">
      <div className="col-12">
        <Heading className="heading" tagName="h2" size="moderate" variant>
          {hasHistoryRoutingForTitles ? (
            <Link dataKey={titleUrl} onAuxClick={onTitleClick} onClick={onTitleClick} to={titleUrl}>
              {title}
              <ChevronRight />
            </Link>
          ) : (
            <a href={titleUrl} onAuxClick={onTitleClick} onClick={onTitleClick}>
              {title}
              <ChevronRight />
            </a>
          )}
        </Heading>
        <ul className="row-bibs__list">
          {displayBibs.map((displayBib, index) => {
            const itemPosition = index + 1; // + 1 so that the count is 1-based.

            return (
              <li className="row-bibs__item" key={displayBib.metadataId}>
                <DisplayBibSlide
                  className="row-bibs__slide"
                  displayBib={displayBib}
                  trackClick={() => trackBibClick({ displayBib, itemPosition })}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

BibsRowBibs.propTypes = {
  displayBibs: PropTypes.arrayOf(displayBibShape).isRequired,
  hasHistoryRoutingForTitles: PropTypes.bool,
  title: PropTypes.string.isRequired,
  titleUrl: PropTypes.string.isRequired,
  trackBibClick: PropTypes.func.isRequired,
  trackTitleClick: PropTypes.func.isRequired
};

export default BibsRowBibs;
